import { Map } from "immutable";

import type { Route, TPageId } from "./route";

import { routes } from "./routes";

let routesMap: Map<string, string>;

export function getPageLocation(pageId: TPageId) {
  if (!routesMap) {
    generateRoutesMap();
  }

  return routesMap.get(pageId);
}

function generateRoutesMap(): Map<string, string> {
  function traverseRoutes(route: Route, prefix: string) {
    const location = prefix + route.main;

    if (route.pageId) {
      routesMap = routesMap.set(route.pageId, location);
    }

    if (route.subRoutes) {
      for (const subRoute of Map(route.subRoutes).values()) {
        traverseRoutes(subRoute, location);
      }
    }
  }
  routesMap = Map();
  traverseRoutes({ main: "", subRoutes: routes } as unknown as Route, "");

  return routesMap;
}
